import { FcGoogle } from "react-icons/fc";   
import {REDIRECT_URL} from '@src/config/constant';

const googleButtonStyle = {
  backgroundColor: '#fff',
  border: '1px solid #ddd',
  color: '#000',
  padding: '12px 20px',
  borderRadius: '8px', // Slightly rounded corners
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  maxWidth: '400px',
  cursor: 'pointer',
  fontSize: '16px',
  transition: 'background-color 0.3s ease',
};
 

function GoogleLoginComponent(props:any) {   
  const handleClick = (e:any) => { 
    e.preventDefault();
    // Perform any additional logic here if needed
    // window.location.href = REDIRECT_URL + window.location.href;
    window.location.href = REDIRECT_URL + window.location.href+"&skip_domain=true";
  }; 
    return (
        <button type="button" style={googleButtonStyle} onClick={handleClick}>
            {FcGoogle({ className: "" })}
            
            {/* <FcGoogle className=""/> */}
            {/* <a className="m-xs-l" href={REDIRECT_URL + window.location.href} onClick={handleClick}> */}
                <span className="m-xs-l">Sign in with Google</span>
            {/* </a>  */}
        </button> 
    );
}

export default GoogleLoginComponent;
